import { Link } from 'react-router-dom';
import { PrivacyHero } from '../components';
import './privacy.css'
const PrivacyPolicy = () => {
    return (
        <div className="privacy-page">
            <PrivacyHero />
            <div className="legal-content-section">
                <div className="legal-content-container container">
                    <div className="legal-content-text">
                        This Privacy Policy explains how <span className="text-highlight">flowdo</span> (“we”, “our”, “us”) collects, uses, stores, and protects personal information when you use our platform and services.<br />
                        By signing up for and using flowdo, you (“User”, “you”, “your”) agree to the practices described in this Privacy Policy. If you do not agree, please stop using the platform.<br />
                        <strong>1. Information We Collect</strong>
                        When you use flowdo, we may collect the following information:<br />
                        <ol>
                            <li><span className="text-highlight">(1).Account Information:</span></li>
                            <ol>
                                <li>• Full name</li>
                                <li>• Company name (if applicable)</li>
                                <li>• Email address</li>
                                <li>• Mobile number</li>
                            </ol>
                            <li><span className="text-highlight">(2).User-Added Information:</span></li>
                            <ol>
                                <li>• Tasks created, assigned, and tracked within the system</li>
                                <li>• Names and emails of additional users added by a company administrator</li>
                            </ol>
                            <li><span className="text-highlight">(3).Technical Information:</span></li>
                            <ol>
                                <li>• Device details, browser type, operating system</li>
                                <li>• IP address and log data for security and troubleshooting</li>
                            </ol>
                        </ol>

                        <strong>2. How We Use Your Information</strong>
                        We use collected data strictly for the following purposes:<br />
                        <ol>
                            <li>• To <span className="text-highlight">create and manage user accounts.</span></li>
                            <li>• To provide access to <span className="text-highlight">task management features.</span></li>
                            <li>• To send <span className="text-highlight">notifications and reminders</span> (via email and/or SMS).</li>
                            <li>• To enable <span className="text-highlight">company administrators</span> to manage their users.</li>
                            <li>• To improve, maintain, and secure the flowdo platform.</li>
                            <li>• To comply with <span className="text-highlight">legal or regulatory requirements.</span></li>
                        </ol>
                        We <span className="text-highlight">do not use your personal information for marketing</span> without your explicit consent.<br />

                        <strong>3. Sharing of Information</strong>
                        We respect your privacy and do <span className="text-highlight">not sell, rent, or trade personal information</span> to third parties.<br />
                        Your data may only be shared in the following limited situations:<br />
                        <ol>
                            <li>• With service providers or partners who assist in operating flowdo (e.g., cloud hosting, email services)</li>
                            <li>• If required by law, regulation, or legal process.</li>
                            <li>• With explicit permission from the company administrator or user.</li>
                        </ol>

                        <strong>4. Data Ownership</strong>
                        <ol>
                            <li>• All data entered into flowdo (including tasks, user details, and company-related information) is owned by the <span className="text-highlight">respective user or company.</span></li>
                            <li>•flowdo will not view, edit, or use your data except when:</li>
                            <ol>
                                <li>Authorized by you or your company's administrator, or</li>
                                <li>Legally required.</li>
                            </ol>
                        </ol>

                        <strong>5. Data Security</strong>
                        <ol>
                            <li>• We use <span className="text-highlight">industry-standard security measures</span> (encryption, firewalls, secure servers) to protect your information from unauthorized access, loss, misuse, or disclosure.</li>
                            <li>• While we take reasonable steps to safeguard your data, no method of electronic storage or transmission is completely secure, and we cannot guarantee absolute security.</li>
                        </ol>

                        <strong>6. Data Retention</strong>
                        <ol>
                            <li>• We retain your information only for as long as necessary to provide flowdo services or as required by law.</li>
                            <li>• If you delete your account, we will delete or anonymize your personal data within a reasonable timeframe, except where retention is required for legal, regulatory, or security purposes.</li>
                        </ol>
                        <strong>7. User Rights</strong>
                        Depending on your location, you may have certain rights regarding your personal data, including:<br />
                        <ol>
                            <li>• Accessing the information we hold about you.</li>
                            <li>• Requesting correction of inaccurate or incomplete data.</li>
                            <li>• Requesting deletion of your data (subject to legal or operational limits).</li>
                            <li>• Withdrawing consent for non-essential data processing (if applicable).</li>
                        </ol>
                        Requests can be made by contacting us at <Link to="mailto:info@flowdo.biz">info@flowdo.biz</Link>.<br />
                        
                        <strong>8. Cookies & Tracking</strong>
                        <ol>
                            <li>• flowdo may use cookies or similar technologies to enhance user experience, track platform usage, and improve services.</li>
                            <li>• You may disable cookies in your browser, but some features of flowdo may not function properly.</li>
                        </ol>
                        <strong>9. International Data Transfers</strong>
                        As flowdo operates from <span className="text-highlight">Dubai, UAE</span> with a branch in <span className="text-highlight">India</span>, your data may be transferred and processed across these locations. We take steps to ensure adequate protection of your personal information regardless of location.<br />
                        <strong>10. Children’s Privacy</strong>
                        flowdo is not directed at children under the age of 15. We do not knowingly collect personal data from minors. If you believe a child has provided us with personal data, please contact us, and we will take steps to delete it.<br />
                        <strong>11. Changes to Privacy Policy</strong>
                        We may update this Privacy Policy from time to time. Any changes will be posted on our website with the updated “Last Updated” date. Continued use of flowdo after changes indicates acceptance of the revised policy.<br />
                        <strong>12. Contact Us</strong>
                        If you have questions or concerns about this Privacy Policy or how your data is handled, please contact us at <Link to="mailto:info@flowdo.biz">info@flowdo.biz</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
